const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.980392%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12.484375 24.835938 C 5.675781 24.835938 0.136719 19.296875 0.136719 12.484375 C 0.136719 5.675781 5.675781 0.136719 12.484375 0.136719 C 19.296875 0.136719 24.835938 5.675781 24.835938 12.484375 C 24.835938 19.296875 19.296875 24.835938 12.484375 24.835938 Z M 12.484375 24.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.484375 16.730469 C 11.800781 16.730469 11.246094 16.175781 11.246094 15.492188 L 11.246094 5.492188 C 11.246094 4.808594 11.800781 4.253906 12.484375 4.253906 C 13.171875 4.253906 13.726562 4.808594 13.726562 5.492188 L 13.726562 15.492188 C 13.726562 16.175781 13.171875 16.730469 12.484375 16.730469 Z M 12.484375 16.730469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.484375 20.71875 C 12.160156 20.71875 11.839844 20.585938 11.609375 20.351562 C 11.554688 20.296875 11.5 20.234375 11.453125 20.167969 C 11.410156 20.101562 11.375 20.027344 11.34375 19.949219 C 11.3125 19.875 11.289062 19.800781 11.273438 19.722656 C 11.257812 19.640625 11.246094 19.5625 11.246094 19.480469 C 11.246094 19.152344 11.378906 18.832031 11.609375 18.601562 C 11.667969 18.542969 11.730469 18.492188 11.796875 18.449219 C 11.867188 18.402344 11.9375 18.363281 12.011719 18.332031 C 12.085938 18.304688 12.164062 18.277344 12.246094 18.261719 C 12.402344 18.230469 12.570312 18.230469 12.726562 18.261719 C 12.808594 18.277344 12.886719 18.304688 12.960938 18.332031 C 13.035156 18.363281 13.105469 18.402344 13.171875 18.449219 C 13.242188 18.492188 13.304688 18.542969 13.363281 18.601562 C 13.589844 18.832031 13.726562 19.152344 13.726562 19.480469 C 13.726562 19.804688 13.59375 20.125 13.363281 20.351562 C 13.304688 20.414062 13.242188 20.464844 13.171875 20.507812 C 13.105469 20.550781 13.035156 20.589844 12.960938 20.621094 C 12.886719 20.652344 12.808594 20.679688 12.726562 20.695312 C 12.648438 20.710938 12.566406 20.71875 12.484375 20.71875 Z M 12.484375 20.71875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.7b7494f104060a32cfc47d1c015241bc.svg";
export { ForwardRef as ReactComponent };